import { mergePathConfig } from 'src/navigation/linking/utils';
export const notificationStackLinking = {
    screens: {},
};
export const notificationTabsLinking = {
    screens: {
        Notification_Home: {
            path: 'notification/*',
            ...mergePathConfig([], ['tabID']),
        },
    },
};
